
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import InputText from "../../shared/input/new/InputText"
import InputPassword from "../../shared/input/new/InputPassword"
import { gibLoginPortal } from "../../../features/e-Arsiv/eArsivSlice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            margin-block: 20px;
            padding: 0 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 100%;
            min-width: 900px;
            .col{
                width: 600px;
                p{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                }
                .row{
                    width: 100%;
                    margin-block: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                }
            }
            h3{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-xl);
            }
        }
        .error-message{
            margin-bottom: 20px;
            color: var(--color-main);
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-sm);
        }
        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 20px;

        }
    }
`

const GibLoginModal = () => {


    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const {errorMessage, isLoadingGibLogin} = useSelector((state) => state.eArsiv)

    const [isShow, setIsShow] = useState(false)
  
    const dispatch = useDispatch()
    const [data, setData] = useState({
      userName:"",
      password:"",
      unvanAdSoyad:"",
      iban:"",
      kolayAdres:"",
      not:""
    })
  
    const handleChange = (e) => {
      setData((prev) => ({...prev, [e?.target?.name]: e?.target?.value}))
    }
  
    const showPassword = () => {
      setIsShow((prev) => !prev)
    }

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        if (data?.userName !== "" && data?.password !== "") {
            dispatch(gibLoginPortal({"username": data?.userName,"password": data?.password}))
        }
    }


  return (
    <ModalContainer onClick={() => dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="content">
                <h3>GİB'e Giriş Yapın</h3>
                <div className="col">
                    {/* <p>GİB Giriş Bilgileri</p> */}

                    <div className="row">
                      <InputText data={data?.userName} setData={(e) => handleChange(e)} name={"userName"} labelText={"Kullanıcı Adı"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                      <InputPassword auto={"new-passoword"} data={data?.password} setData={(e) => handleChange(e)} type={isShow ? "text" : "password"} name={"password"} labelText={"Şifre"} inputWidth={"100%"} showPassword={showPassword} isShow={isShow} />
                    </div>

                     {/* <div className="col">
                        <p>Hesap Bilgileri</p>

                        <div className="row">
                        <InputText data={data?.unvanAdSoyad} setData={(e) => handleChange(e)} name={"unvanAdSoyad"} labelText={"Hesa Sahibi Ünvanı / Adı Soyadı"} inputWidth={"100%"} />
                        </div>
                        <div className="row">
                        <InputIban data={data?.iban} setData={(e) => handleChange(e)} name={"iban"} labelText={"IBAN"} borderColor="mainBorderColor" inputWidth={"100%"} />
                        </div>
                        <div className="row">
                        <InputSelect data={kolayAdresTuru} setData={setKolayAdresTuru} name={"kolayAdresTuru"} labelText={"Kolay Adres Türü"} initialOptions={kolayAdresData} inputWidth={"100%"} />
                        </div>
                        <div className="row">
                        <InputText data={data?.kolayAdres} setData={(e) => handleChange(e)} name={"kolayAdres"} labelText={"Kolay Adres"} inputWidth={"100%"} />
                        </div>
                    </div>

                    <div className="col">
                        <p>Not</p>
                        <div className="row">
                        <InputText data={data?.not} setData={(e) => handleChange(e)} name={"not"} labelText='Not' inputWidth={"100%"} />
                        </div>
                    </div> */}
                </div>
            </div>

            <div className="error-message">
                <p>{errorMessage}</p>
            </div>

            <div className='button-grp'>
                <Btn color='#E85446' bgColor='transparent' padding='10px' width={"150px"} handleClick={handleSubmit}>{isLoadingGibLogin ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} /> : "Giriş Yap" }</Btn>

            </div>
        </div>
    </ModalContainer>
  )
}

export default GibLoginModal